import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import Home from '../views/Home'
import Pay from '../components/Pay'
import SinglePay from '../views/SinglePay'
import InstallmentPay from '../views/InstallmentPay'
import Page from '../views/Page'
import Login from '../views/Login'
import Register from '../views/Register'
// USER
import User from '../views/User/index'
import MyAccount from '../views/User/MyAccount'
import UpdateAccount from '../views/User/UpdateAccount'

import Admins from '../views/Admin/Admins/index'
import AdminsCreate from '../views/Admin/Admins/create'
import AdminsDetail from '../views/Admin/Admins/detail'
import AdminsList from '../views/Admin/Admins/list'

import Reports from '../views/Admin/Reports/index'
import ReportsMain from '../views/Admin/Reports/main-report'

import Users from '../views/Admin/Users/index'
import UsersCreate from '../views/Admin/Users/create'
import UsersDetail from '../views/Admin/Users/detail'
import UsersList from '../views/Admin/Users/list'


import Transactions from '../views/Admin/Transactions/index'
import TransactionsCreate from '../views/Admin/Transactions/create'
import TransactionsDetail from '../views/Admin/Transactions/detail'
import TransactionsList from '../views/Admin/Transactions/list'

import Permission from '../views/Admin/Permission/index'
import PermissionList from '../views/Admin/Permission/list'

import Companies from '../views/Admin/Companies/index'
import CompaniesList from '../views/Admin/Companies/list'
import CompaniesCreate from '../views/Admin/Companies/create'
import CompaniesDetail from '../views/Admin/Companies/detail'
import CompaniesDetailPayment from '../views/Admin/Companies/payment'
import CompaniesDetailColor from '../views/Admin/Companies/color'

import Pages from '../views/Admin/Pages/index'
import PagesList from '../views/Admin/Pages/list'
import PagesCreate from '../views/Admin/Pages/create'
import PagesDetail from '../views/Admin/Pages/detail'

import Payments from '../views/Admin/Payments/index'
import PaymentsList from '../views/Admin/Payments/list'
import PaymentsCreate from '../views/Admin/Payments/create'
import PaymentsDetail from '../views/Admin/Payments/detail'

import PaySuccess from '../views/PaySuccess';
import PayFail from '../views/PayFail';


Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/pay",
    name: "Pay",
    component: Pay,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/sayfa/:slug",
    name: "Page",
    component: Page,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/tekcekim",
    name: "SinglePay",
    component: SinglePay,
    meta:{
      auth: false,
      guest: false
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/odeme/basarili",
    name: "PaySuccess",
    component: PaySuccess,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/odeme/basarisiz",
    name: "PayFail",
    component: PayFail,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/taksitlicekim",
    name: "InstallmentPay",
    component: InstallmentPay,
    meta:{
      auth: false,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta:{
      auth: false,
      guest: true,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta:{
      auth: false,
      guest: true,
    },
    property: {
      is_admin: false,
    }
  },
  {
    path: "/yonetim",
    redirect: "/yonetim/liste",
    name: "Admins",
    component: Admins,
    meta:{
      auth: true,
      guest: false,
    },
    children: [
      {
        path: "liste",
        name: "AdminsList",
        component: AdminsList,
        meta:{
          permission: 'admin_list',
          auth: true,
          guest: false,
        },
      },
      {
        path: "olustur",
        name: "AdminsCreate",
        component: AdminsCreate,
        meta:{
          permission: 'admin_update',
          auth: true,
          guest: false,
        },
      },
      {
        path: "detay/:id",
        name: "AdminsDetail",
        component: AdminsDetail,
        meta:{
          permission: 'admin_show',
          auth: true,
          guest: false,
        },
      },
      {
        path: "firmalar",
        redirect: "firmalar/liste",
        name: "Companies",
        component: Companies,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "CompaniesList",
            component: CompaniesList,
            meta:{
              permission: 'client_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "olustur",
            name: "CompaniesCreate",
            component: CompaniesCreate,
            meta:{
              permission: 'client_update',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id",
            name: "CompaniesDetail",
            component: CompaniesDetail,
            meta:{
              permission: 'client_show',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id/odeme",
            name: "CompaniesDetailPayment",
            component: CompaniesDetailPayment,
            meta:{
              permission: 'client_payment_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id/renk",
            name: "CompaniesDetailColor",
            component: CompaniesDetailColor,
            meta:{
              permission: 'client_color_list',
              auth: true,
              guest: false,
            },
          },
        ]
      },
      {
        path: "raporlar",
        redirect: "raporlar/ana-rapor",
        name: "Reports",
        component: Reports,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "ana-rapor",
            name: "ReportsMain",
            component: ReportsMain,
            meta:{
              permission: 'user_list',
              auth: true,
              guest: false,
            },
          },
        ]
      },
      {
        path: "kullanicilar",
        redirect: "kullanicilar/liste",
        name: "Users",
        component: Users,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "UsersList",
            component: UsersList,
            meta:{
              permission: 'user_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "olustur",
            name: "UsersCreate",
            component: UsersCreate,
            meta:{
              permission: 'user_update',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id",
            name: "UsersDetail",
            component: UsersDetail,
            meta:{
              permission: 'user_show',
              auth: true,
              guest: false,
            },
          },
        ]
      },
      {
        path: "yetkiler",
        redirect: "yetkiler/liste",
        name: "Permission",
        component: Permission,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "PermissionList",
            component: PermissionList,
            meta:{
              permission: 'permission_role_create',
              auth: true,
              guest: false,
            },
          }
        ]
      },
      {
        path: "sayfalar",
        redirect: "sayfalar/liste",
        name: "Pages",
        component: Pages,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "PagesList",
            component: PagesList,
            meta:{
              permission: 'page_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "olustur",
            name: "PagesCreate",
            component: PagesCreate,
            meta:{
              permission: 'page_update',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:slug",
            name: "PagesDetail",
            component: PagesDetail,
            meta:{
              permission: 'page_show',
              auth: true,
              guest: false,
            },
          },
        ]
      },
      {
        path: "odeme-yontemleri",
        redirect: "odeme-yontemleri/list",
        name: "Payments",
        component: Payments,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "PaymentsList",
            component: PaymentsList,
            meta:{
              permission: 'payment_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "olustur",
            name: "PaymentsCreate",
            component: PaymentsCreate,
            meta:{
              permission: 'payment_create',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id",
            name: "PaymentsDetail",
            component: PaymentsDetail,
            meta:{
              permission: 'payment_show',
              auth: true,
              guest: false,
            },
          },
        ]
      },
      {
        path: "odemeler",
        redirect: "odemeler/list",
        name: "Transactions",
        component: Transactions,
        meta:{
          auth: true,
          guest: false,
        },
        children: [
          {
            path: "liste",
            name: "TransactionsList",
            component: TransactionsList,
            meta:{
              permission: 'transaction_list',
              auth: true,
              guest: false,
            },
          },
          {
            path: "olustur",
            name: "TransactionsCreate",
            component: TransactionsCreate,
            meta:{
              permission: 'transaction_update',
              auth: true,
              guest: false,
            },
          },
          {
            path: "detay/:id",
            name: "TransactionsDetail",
            component: TransactionsDetail,
            meta:{
              permission: 'transaction_show',
              auth: true,
              guest: false,
            },
          },
        ]
      },
    ]
  },
  {
    path: "/hesabim",
    redirect: "/hesabim/islemler",
    name: "User",
    component: User,
    meta:{
      auth: true,
      guest: false,
    },
    children: [
      {
        path: "islemler",
        name: "MyAccount",
        component: MyAccount,
        meta:{
          permission: 'my_account',
          auth: true,
          guest: false,
        },
      },
      {
        path: "guncelleme",
        name: "UpdateAccount",
        component: UpdateAccount,
        meta:{
          permission: 'update_account',
          auth: true,
          guest: false,
        },
      },
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes
});

const auth = {
	loggedIn() {
		return store.getters['auth/isLoggedIn']
  },
  detail(){
    return store.getters['auth/user_detail']
  },
	permission(permission) {
	    return store.getters['auth/permission'](permission)
	}
}

router.beforeEach((to, from, next) => {
  
  let authRequired = false
	if(to && to.meta && to.meta.auth){
    authRequired = true
  }
  
  let guestRequired = false
  if(to && to.meta && to.meta.guest){
    guestRequired = true
  }
    
  if (authRequired && !auth.loggedIn() && to.name !== 'Login')
  {
    console.log('RUN2');
    router.push({name: 'Login'});
    return;
  }
  
  if (guestRequired && auth.loggedIn())
  {
    router.push({name: 'Home'});
    return;
  }
	if (auth.loggedIn() && !_.isUndefined(to.meta.permission) && !_.isNull(to.meta.permission) && !auth.permission(to.meta.permission))
	{
		router.push({name: 'Home'});
		return;
	}

  next();
})

export default router
